import React, { memo, useEffect, useRef, useState } from 'react'
import './style.css'
import Layout from '../../../components/Layout'
import Welcome from '../../../components/Welcome'
import Button from '../../../components/ButtonNew'

import { useNavigate } from 'react-router-dom'

import { getUrlParams } from '../../../utils/helpers/common'
import { trackEvent } from '../../../analytics'
import { EVENTS } from '../../../analytics/events'
import constants from '../../../constants'
import { deeplinks } from '../../../constants/common'

import ArrowRight from '../../../assets/icons/common/arrow-right.svg'
import MetaTags from '../../../components/MetaTags/MetaTags'
import anayaImgUrls from '../../../constants/anaya-constants'
import OurProgram from './Components/OurProgram'
import WhyAnayaCare from './Components/WhyAnaya'
import CareSpecialist from './Components/CareSpecialist'
import CoinDetails from './Components/CoinDetails'
import Journey from './Components/Journey'
import Faqs from './Components/Faqs'
import Callback from './Components/Callback'
import Copyrights from './Components/Copyrights'
import useSetTheme from '../../../hooks/useSetTheme'

const AnayaCarePage = () => {
  const navigate = useNavigate()
  const [urlParams, setUrlParams] = useState(null)
  const innerRef = useRef(null)
  const [addbottom, setBottom] = useState()
  useSetTheme(constants.CARE_PROGRAM_TYPE.ANAYA)
  const deeplinkToRedirect = deeplinks[constants.CARE_PROGRAM_TYPE.ANAYA]

  useEffect(() => {
    const urlParams = getUrlParams()
    setUrlParams(urlParams)
    trackEvent(EVENTS.PAGE_VIEW, {
      screenName: 'Programs Screen',
      pageName: 'Viemax Care Program',
      ...urlParams,
    })
  }, [])

  useEffect(() => {
    const div = innerRef.current
    // subscribe event
    div.addEventListener('scroll', handleOnScroll)
    return () => {
      // unsubscribe event
      div.removeEventListener('scroll', handleOnScroll)
    }
  }, [])

  const handleOnScroll = (e) => {
    // NOTE: This is for the sake of demonstration purpose only.
    // Doing this will greatly affect performance.
    e.target.scrollTop >= 625 ? setBottom(true) : setBottom(false)
  }

  const handleJoinProgramClick = () => {
    localStorage.removeItem('auth_token')
    navigate(
      `/psp/signup-user?support_program_type=${constants.CARE_PROGRAM_TYPE.ANAYA}`,
    )
  }

  return (
    <Layout>
      <MetaTags
        title="Anaya Care Program"
        description="Anaya Care Program"
        image={anayaImgUrls.heroSection}
        url={window.location.href}
        type="website"
        siteName="GoodFlip"
      />

      <div
        className="container h-[100vh]"
        style={{ padding: 0, overflow: 'auto' }}
        ref={innerRef}
      >
        <div className="min-w-sm max-w-lg pb-[98px] relative mx-auto w-full bg-white">
          <div className="space-y-4">
            <Welcome
              careProgramType={constants.CARE_PROGRAM_TYPE.ANAYA}
              welcomeImage={anayaImgUrls.heroSection}
              storeUrl={deeplinkToRedirect}
              hideDownloadBtn={
                urlParams?.source === 'mytatva' && urlParams?.platform === 'app'
              }
              buttonText="Join the Program"
              onButtonClick={handleJoinProgramClick}
            />
            {/* Our Program Section */}
            <OurProgram />
            {/* Why Anaya Care Section */}
            <WhyAnayaCare />
            {/* Care Specialist Section */}
            <CareSpecialist />
            {/* Coin Details Section */}
            <CoinDetails />
            {/* Journey Steps Section */}
            <Journey />
            {/* Faqs */}
            <Faqs />
            {/* Callback */}
            <Callback />
            {/* Copyrights */}
            <Copyrights />
          </div>
          <div
            className={`min-w-sm max-w-lg w-full mx-auto text-center fixed z-15 bg-white bottom-gray-class ${addbottom ? 'bottom-0' : 'bottom-[-90px]'}`}
            style={{
              padding: '15px 0',
            }}
          >
            {(urlParams?.source !== 'mytatva' ||
              urlParams?.platform !== 'app') && (
              <div className="px-4">
                <Button
                  onClick={handleJoinProgramClick}
                  variant="contained"
                  fullWidth
                >
                  Join the Program
                  <img src={ArrowRight} />
                </Button>
              </div>
            )}
          </div>
        </div>
      </div>
    </Layout>
  )
}

export default memo(AnayaCarePage)
